
import register from 'ShopUiBundle/modules/app/registry';
import './view-loader.scss';

// tslint:disable-next-line
register('view-loader', () => import(/* webpackMode: "lazy" */'./view-loader'));
